import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const serviceId = 3
const slug = 'solar-panel-and-battery-installations-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Solar Panel & Battery Installations",
        description: "Installing solar energy systems and battery storage solutions to promote sustainability and reduce energy costs.",
        keywords: "solar panel installations Sydney, solar battery storage, renewable energy solutions, licensed electricians Sydney, solar power systems, energy-efficient installations, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Solar Panel & Battery Installations',
    description: 'Installing solar energy systems and battery storage solutions to promote sustainability and reduce energy costs. ',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
